<template>
  <el-config-provider :locale="locale">
    <!-- 区域1：顶部横幅 -->
    <div style="background-color: #FEEFEF">
      <section class="hero-section">
        <div class="hero-content">
          <p class="hero-title">专业<span class="important_text">股票模拟交易软件</span>，智慧投资起点</p>
          <div class="sim_td_text">
            <span>OrderPro悦高智享交易终端，<span class="important_text">免费股票模拟交易软件</span>
              助力<span class="important_text">新手股票投资学习</span>，让您在零风险环境中掌握<span
                  class="important_text">A股投资</span>精髓</span>

          </div>

          <button class="hero-btn" @click="download(version_new_url)">
            立即下载 OrderPro

          </button>
          <!--          <div class="version-text">版本: {{version_new}}</div>-->

          <div class="sim_td_list_text">
            <span class="badge" style="margin-top: 5px">✓&nbsp;完全免费&nbsp;&nbsp;&nbsp;</span>
            <span class="badge" style="margin-left: 10px">✓&nbsp;零风险学习</span>
            <span class="badge" style="margin-left: 10px">✓&nbsp;专业级工具</span>

          </div>

        </div>
      </section>
    </div>

    <!-- 区域2：产品介绍 -->
    <div style="background-color: #fff">
      <section class="product-section">
        <h2 class="product-title">为什么选择我们的A股模拟交易平台</h2>
        <div class="product-grid">
          <div class="product-item">
            <img class="product-icon" src="../../assets/index/service-bag@2x.png" alt="智能选股"/>
            <div class="product-name">零风险投资学习</div>
            <div class="product-desc">
              真实A股环境模拟，让新手股票投资学习更安全。无需担心资金损失，专注提升投资技能。
            </div>
          </div>
          <div class="product-divider"></div>
          <div class="product-item">
            <img class="product-icon" src="../../assets/index/servicee-user@2x.png" alt="模拟交易"/>
            <div class="product-name">智能决策支持</div>
            <div class="product-desc">
              AI算法辅助分析，让股票交易决策更加精准。专业级分析工具，提升投资成功率。
            </div>
          </div>
          <div class="product-divider"></div>
          <div class="product-item">
            <img class="product-icon" src="../../assets/index/service-book@2x.png" alt="投资分析"/>
            <div class="product-name">专业能力提升</div>
            <div class="product-desc">
              完整投资教育体系，从入门到专业进阶。系统化学习路径，快速成长为投资高手。
            </div>
          </div>
        </div>
      </section>
      <!--
      <section class="product-section">
        <h2 class="product-title">OrderPro 股票模拟交易软件核心功能</h2>
        <div class="product-grid">
          <div class="product-item">
            <img class="product-icon" src="../../assets/index/service-bag@2x.png" alt="智能选股"/>
            <div class="product-name">实时A股行情同步</div>
            <div class="product-desc">
              与真实股市数据同步，让模拟交易更贴近实战
            </div>
          </div>
          <div class="product-divider"></div>
          <div class="product-item">
            <img class="product-icon" src="../../assets/index/servicee-user@2x.png" alt="模拟交易"/>
            <div class="product-name">深度技术分析</div>
            <div class="product-desc">
              专业级技术指标，助力股票投资决策分析
            </div>
          </div>
          <div class="product-divider"></div>
          <div class="product-item">
            <img class="product-icon" src="../../assets/index/service-book@2x.png" alt="投资分析"/>
            <div class="product-name">智能策略回测</div>
            <div class="product-desc">
              验证投资策略有效性，提升交易成功率
            </div>
          </div>
          <div class="product-divider"></div>
          <div class="product-item">
            <img class="product-icon" src="../../assets/index/service-book@2x.png" alt="投资分析"/>
            <div class="product-name">风险控制工具</div>
            <div class="product-desc">
              完善的风险管理功能，让投资学习更安全
            </div>
          </div>
        </div>
      </section>
      -->
    </div>
    <!-- 区域3：产品服务（价格/版本） -->
    <div style="background-color: #FEEFEF">
      <section class="services-section">
        <h2 class="services-title">产品服务</h2>
        <div class="container-align">
          <div class="services-grid">
            <!-- 个人版 -->
            <div class="service-card">
              <div class="service-header">个人版
                <span style="display: block;font-size: 12px;color: #717171">安全入门，稳健起步</span>
              </div>

              <div class="service-tag">
                <img class="service-tag-icon" src="../../assets/index/sy-xx@2x.png" alt="限时图标"/>
                <span class="service-tag-text">{{grb_xsmf}}</span>
              </div>
              <button class="service-btn" v-if="username" @click="showBuy('gr')">立即购买</button>
              <button v-else class="service-btn" @click="to_register">立即注册</button>
              <div class="service-features">
                <div class="feature-row"><span class="feature-left">目标用户：</span><span
                    class="feature-right">股市新手、个人投资学习者</span></div>
                <div class="feature-row"><span class="feature-left">资金规模：</span><span
                    class="feature-right ">最高30万元虚拟资金</span></div>
                <div class="feature-row"><span class="feature-left">核心定位：</span><span
                    class="feature-right ">零门槛学习，安全实践环境</span></div>
                <div class="feature-row"><span class="feature-left">交易体验：</span><span
                    class="feature-right">涵盖所有8个基础交易功能</span></div>
              </div>
              <div class="service-features">
                <div class="service-tag-cj">
                  <span class="service-tag-cj-text">适用场景</span>
                </div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">股票投资零基础用户的入门学习</span></div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">验证基础投资理念和简单策略</span></div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">熟悉股票交易流程和规则</span></div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">培养正确的投资心态和习惯</span></div>
              </div>
            </div>
            <!-- 专业版 -->
            <div class="service-card">
              <div class="service-header">专业版
                <span style="display: block;font-size: 12px;color: #717171">智能决策，高效交易</span>
              </div>
              <div class="service-tag" style="gap: 5px">
                <span class="bj-price-text">{{ this.pay_price_bj }}</span>
                <span class="bj-ms-tag-text">元/年&nbsp;&nbsp;
                <span v-if="zy_discount_flag==='1'" style="font-size: 12px">限时{{zy_discount_rate}}折</span>
                </span>

              </div>
              <button class="service-btn" v-if="username" @click="showBuy('zy')">立即购买</button>
              <button v-else class="service-btn" @click="to_register">立即注册</button>
              <div class="service-features">
                <div class="feature-row"><span class="feature-left">目标用户：</span><span
                    class="feature-right">有经验的投资者、策略研究者</span></div>
                <div class="feature-row"><span class="feature-left">资金规模：</span><span
                    class="feature-right ">最高100万元虚拟资金</span></div>
                <div class="feature-row"><span class="feature-left">核心定位：</span><span
                    class="feature-right ">AI赋能的专业投资工具</span></div>
                <div class="feature-row"><span class="feature-left">交易体验：</span><span
                    class="feature-right">个股分析、选股推荐、趋势预测</span></div>
              </div>

              <div class="service-features">
                <div class="service-tag-cj">
                  <span class="service-tag-cj-text">适用场景</span>
                </div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">验证和优化复杂投资策略</span></div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">进行量化交易策略研究</span></div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">提升投资决策的效率和准确性</span></div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">专业投资技能的进阶提升</span></div>
              </div>

            </div>
            <!-- 机构版 -->
            <div class="service-card">
              <div class="service-header">机构版
                <span style="display: block;font-size: 12px;color: #717171">教学管理，规模运营</span>
              </div>
              <div class="service-tag">
                <img class="service-tag-icon" style="width: 20px;height: 20px" src="../../assets/index/kf@2x.png"
                     alt="客服图标"/>
                <span class="service-tag-text">按需报价</span>
              </div>
              <button class="service-btn" @click.prevent="showQRCode">立即咨询</button>
              <div class="service-features">
                <div class="feature-row"><span class="feature-left">目标用户：</span><span
                    class="feature-right">金融培训、高校、企业培训</span></div>
                <div class="feature-row"><span class="feature-left">资金规模：</span><span
                    class="feature-right ">无限制(可灵活设定)</span></div>
                <div class="feature-row"><span class="feature-left">核心定位：</span><span
                    class="feature-right ">专业教学工具和批量管理平台</span></div>
                <div class="feature-row"><span class="feature-left">交易体验：</span><span
                    class="feature-right">一键创建学员账户、统一配置</span></div>
              </div>

              <div class="service-features">
                <div class="service-tag-cj">
                  <span class="service-tag-cj-text">适用场景</span>
                </div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">高校金融专业实训教学</span></div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">金融机构内部员工培训</span></div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">证券公司客户教育项目</span></div>
                <div class="feature-row-cj">
                  <img class="service-tag-cj-icon" src="../../assets/index/kxdg-red.svg" alt=""/>
                  <span class="sycj-left">投资顾问资格认证培训</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <el-dialog
        v-model="dialogVisible"
        width="10rem"
        style="text-align: center"
    >
      <div style="height: 200px;text-align: center">
        <img style="width: 150px" src="../../assets/register/jszc_qr.png" alt="">
        <span style="display: block">{{ qr_title }}</span>
      </div>

    </el-dialog>
    <!-- 区域4：用户评价 -->
    <section class="contact-section">
      <h2 class="contact-title">用户评价</h2>
      <div class="testimonials-grid">
        <div class="testimonial-card">
          <p>"作为投资新手，OrderPro让我在零风险环境中学会了<strong>股票交易</strong>。界面专业，功能强大！"</p>
          <div class="testimonial-author">
            <strong>李先生</strong> - 个人投资者
          </div>
        </div>

        <div class="testimonial-card">
          <p>"这是我用过最好的<strong>免费股票模拟交易软件</strong>，数据准确，分析工具专业。"</p>
          <div class="testimonial-author">
            <strong>张女士</strong> - 资深交易员
          </div>
        </div>

        <div class="testimonial-card">
          <p>"我们学校选择OrderPro作为<strong>投资学习</strong>教学工具，学生反馈非常好。"</p>
          <div class="testimonial-author">
            <strong>王教授</strong> - 金融学院
          </div>
        </div>
      </div>
    </section>


    <!-- QR Code Modal -->
    <div v-if="isQRCodeVisible" class="qr-modal" @click="hideQRCode">
      <div class="qr-content" @click.stop>
        <div class="qr-body">
          <h3 class="qr-title">微信扫码咨询</h3>
          <span class="qr-title2">扫描下方二维码添加商务顾问微信</span>
          <img src="../../assets/index/swhz_qr.png" alt="Contact QR Code" class="qr-image">
          <button class="close-btn" @click="hideQRCode">&times;</button>
        </div>
      </div>
    </div>

  </el-config-provider>

  <el-dialog
      v-model="buyBoxShow"
      :width="isMobile ? '90%' : '20rem'"
      top="2rem"
      custom-class="responsive-dialog"
  >
    <template #title class="cz_dialog">
      <span style="color: #2A2A2A;font-size: 14px;font-weight: 600;float: left;padding-top: 5px">充值账号：</span>
      <div class="cz_user_box" style="display: inline-block;line-height: 30px;float: left;margin-top: -4px">
        <img class src="@/assets/index/tx@2x.png"
             style="display: inline-block;margin-right: 5px;float: left;margin-top: 2px;width: 32px;" alt=""/>
        <div class="cz_user_info" style="display: inline-block;line-height: 30px;float: left">
          <span style="color: #666666;display: block;font-size: 14px;line-height: 14px;margin-bottom: 5px">{{
              username
            }}</span>
          <span v-if="expiration_date.slice(0, 4) === '2999' && this.acc_type === '0'" style="color: #9C9C9C;display: block;font-size: 12px;line-height: 12px">期限:永久</span>
          <span v-else style="color: #9C9C9C;display: block;font-size: 12px;line-height: 12px">{{
              expiration_date
            }} 到期</span>
        </div>

      </div>


    </template>
    <div class="version_card_box">

      <div class="version_card" :class="version_card_nk_00"
           @click="version_card_click(pay_price_bj,'1',365)">
        <span :class="version_card_nk_01">专业版</span>
        <span :class="version_card_nk_02">初始模拟资金100万</span>
        <span :class="version_card_nk_03">¥ <span :class="version_card_nk_04"
        >{{ pay_price_bj }}</span> 元
        <span v-if="zy_discount_flag==='1'" style="font-size: 12px;">限时{{zy_discount_rate}}折</span>
        </span>

      </div>

    </div>

    <div class="version_pay_box">
      <div class="version_pay_left">
        <div class="version_pay_qrcode">
          <div class="qrcode-container"><img id="wx_tpid"
                                          :src="pay_qr_code"
                                          class="qrcode-image"></div>
          <div class="payment-method">
            <img src="@/assets/index/wx@2x.png" alt="" class="payment-icon">
            <span class="payment-text">微信扫码支付</span>
          </div>
        </div>
      </div>
      <div class="version_pay_right">
        <span class="amount-label">应付金额:</span>
        <span class="amount-value">¥ <span
            class="amount-number">{{ pay_price*zy_discount_rate/10 }}</span> 元</span>
        <span class="payment-note">*购买提示:一经使用，概不退费</span>
      </div>
    </div>
    <template #footer>

    </template>
  </el-dialog>

  <el-dialog
      v-model="buyReShow"
      width="13rem"
      top="2rem"
  >
    <div class="zf_success_box">

      <div class="success_1" style="text-align: center;height: 30px">
        <div style="display: inline-block;height: 36px">
          <img src="@/assets/index/zfcg@1x.png" alt="" style="float: left;width: 36px;margin-right: 5px">
          <span style="float: left;line-height: 36px;color: #232323">支付成功</span>
        </div>

      </div>
      <div class="success_2" style="color:#9C9C9C;text-align: center;height: 60px;line-height: 60px">
        可到“个人中心”一“账户管理”中查看详情
      </div>
      <div class="success_3" style="text-align: center">
        <el-button
            @click="showBuy('')"
            type="danger"
            size="medium" plain
        >继续购买
        </el-button
        >
        <el-button type="danger" size="medium" @click="buyReShow=false"
        >关 闭
        </el-button>
      </div>

    </div>

    <template #footer>

    </template>
  </el-dialog>

</template>
<script>

import zhCn from "element-plus/lib/locale/lang/zh-cn";
import {ElMessage} from "element-plus";
import {
  wx_zf_re, sys_user_me, order_bill_create, soft_list, update_receipt_info, sys_app_get_price,
  nickname_change, pwd_change, product_buy_list, product_price, product_list
} from "@/api/system/system";


export default {
  components: {},
  data() {
    return {
      locale: zhCn,
      username: "",
      dialogVisible: false,
      qr_title: "",
      isQRCodeVisible: false,
      version_new: '',
      version_new_url: "",

      grb_xsmf:"限时免费",
      gr_sale_flag:"0",
      zy_sale_flag:"0",

      zy_discount_flag:"0",
      zy_discount_rate:10,



      // 购买相关
      pay_price_jc: 0, //
      pay_price_bj: 0, //
      pay_days_jc: 0,
      pay_days_bj: 0,
      buyBoxShow: false,
      my_version_class: "my_version_wx",  // my_version_yx有效  my_version_wx 无效
      version_name: "专业版",
      // // version_date: "2024-12-30到期",
      // version_date: "2024-11-30已过期",

      pay_price: 469, // 469 899
      pay_days: 180, // 469 899
      order_type: '0', // 0 基础 1 白金
      expiration_date: '--',
      userid: '',
      pay_qr_code: "",
      version_card_bnk_00: "version_card_chose",
      version_card_bnk_01: "",
      version_card_bnk_02: "",
      version_card_bnk_03: "",
      version_card_bnk_04: "",
      version_card_nk_00: "version_card_unset",
      version_card_nk_01: "",
      version_card_nk_02: "",
      version_card_nk_03: "",
      version_card_nk_04: "",
      buyReShow: false,
      zfjgTimerId: null,
      wx_ddh: "",
      // 购买相关结束


    };
  },
  created() {
    this.username = this.$store.getters.getUserName;
    this.get_soft_list()
    this.get_sys_app_get_price();

    if (this.username) {
      this.get_sys_user_me();

    }


    // this.to_search('all');
  },
  mounted() {
    this.username = this.$store.getters.getUserName;

  },
  methods: {
    get_soft_list() {
      soft_list().then(
          (res) => {
            console.log("==get_soft_list==", res.data.data)
            this.version_new = res.data.data.win[0].version_num;
            this.version_new_url = res.data.data.win[0].download_url;


          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );
    },
    download(url) {
      this.$router.push("/download");
      // if (!url) {
      //   ElMessage.warning("下载地址不存在");
      //   return;
      // }
      // // 以新窗口打开，便于浏览器直接下载
      // window.open(url, "_blank");
    },
    buy_click(t) {
      this.dialogVisible = true;
      this.qr_title = t
    },
    showQRCode() {
      this.isQRCodeVisible = true
    },
    hideQRCode() {
      this.isQRCodeVisible = false
    },
    to_register() {
      this.$router.push("/Register");
    },
    //打开支付弹框
    showBuy(buy_type) {
      if (buy_type === 'gr'){
        if(this.gr_sale_flag === '0'){
          ElMessage({
            showClose: true,
            message: '暂未开售',
            type: "warning",
          });
          return
        }
      }
      if (buy_type === 'zy'){
        if(this.zy_sale_flag === '0'){
          ElMessage({
            showClose: true,
            message: '暂未开售',
            type: "warning",
          });
          return
        }
      }
      this.buyBoxShow = true;
      this.buyReShow = false;
      this.version_card_click(this.pay_price_bj, '1', 365);

    },

    // 个人信息查询
    get_sys_user_me() {
      sys_user_me().then(
          (res) => {
            console.log("==get_sys_user_me==", res)
            this.username = res.data.data[0]["user_guid"];
            this.nickname = res.data.data[0]["username"];
            this.balance = res.data.data[0]["balance"];
            this.nickname_edit = this.nickname;
            // 若后端返回固定8位代码，可在此覆盖 user_code
            if (res.data.data[0]["user_code"]) {
              this.user_code = (res.data.data[0]["user_code"] + '').padStart(8, '0').slice(-8);
            } else {
              // 默认以 user_guid 的末8位作为展示
              const ug = (this.username + '').replace(/[^\d]/g, '');
              this.user_code = (ug.slice(-8) || '00000000').padStart(8, '0');
            }
            this.acc_type_zh = res.data.data[0]["acc_type_zh"];
            this.acc_type = res.data.data[0]["acc_type"];
            this.userid = res.data.data[0]["user_guid"];
            this.expiration_date = res.data.data[0]["expired_time"].toString().slice(0, 10);

            if (res.data.data[0]["acc_type"] === '1') {
              this.my_version_class = "my_version_yx";
              this.my_xf_btn = true;
            } else {
              this.my_version_class = "my_version_wx";
              this.my_xf_btn = false;
            }


          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );
    },
    // 查询支付结果
    wx_zf_re_f() {
      var zf_re_url = "http://payapi.yogoo.net/wxzf/result/" + this.wx_ddh.toString() + ".json";
      wx_zf_re(zf_re_url).then(
          (res) => {
            // console.log("=res===", res);
            var res_str = res.data.toString();
            // console.log("=res1===", res_str);
            // console.log("=res2===", res_str.includes("Success"));
            // console.log("=res2===", res_str.includes(this.wx_ddh.toString()));

            // this.wx_ddh = "T2024126163137";
            if (res_str.includes("Success") && res_str.includes(this.wx_ddh.toString())) {
              // if (1===1) {
              if (this.zfjgTimerId) {
                clearInterval(this.zfjgTimerId);
                this.buyBoxShow = false;
                this.buyReShow = true;

                const now = new Date();
                const year = now.getFullYear();
                const month = (now.getMonth() + 1).toString().padStart(2, '0');
                const day = now.getDate().toString().padStart(2, '0');
                const hours = now.getHours().toString().padStart(2, '0');
                const minutes = now.getMinutes().toString().padStart(2, '0');
                const seconds = now.getSeconds().toString().padStart(2, '0');
                var pay_date = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                var data = {
                  user_guid: this.username,
                  // 订单号
                  order_id: this.wx_ddh,
                  // 订单类型
                  product_id: this.order_type,
                  // 订单金额
                  pay_price: this.pay_price*this.zy_discount_rate/10,
                  // 订单折扣
                  discount_rate: this.zy_discount_rate,
                  // 付款时间
                  pay_time: pay_date,
                  // 付款类型
                  pay_type: "0",
                  pay_days: "365",

                };
                // 支付记录传入后台
                order_bill_create(data).then(
                    (res) => {
                      console.log(res.data.meta);
                      if (res.data.meta.code == 200) {
                        console.log("订单支付成功");
                        //  ElMessage({
                        //   showClose: true,
                        //   message: "订单支付成功",
                        //   type: "warning",
                        // });
                        location.reload();
                      } else {
                        console.log("订单支付异常");
                        // ElMessage({
                        //
                        //   showClose: true,
                        //   message: "订单支付异常",
                        //   type: "warning",
                        // });
                      }
                    },
                    (error) => {

                      ElMessage({
                        showClose: true,
                        message: "订单支付失败",
                        type: "warning",
                      });
                      console.log(error);
                    }
                );

              }

              // console.log("==this.zfjgTimerId==",this.zfjgTimerId)
            }

          },
          (error) => {
            console.log(error);
          }
      );
      if (!this.buyBoxShow) {
        if (this.zfjgTimerId) {
          clearInterval(this.zfjgTimerId);
        }
      }
    },

    // 购买订单qr生成
    version_card_click(pay_price, pay_type, pay_days) {
      if (this.zfjgTimerId) {
        clearInterval(this.zfjgTimerId);
      }
      const now = new Date();
      const year = now.getFullYear().toString().padStart(2, '0');
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');

      // console.log(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      this.order_type = pay_type;
      this.pay_price = pay_price;
      this.pay_days = pay_days;
      var ddg_date = year.toString() + month.toString() + day.toString() + hours.toString() + minutes.toString() + seconds.toString();
      this.wx_ddh = "T" + ddg_date.toString() + this.userid;
      this.pay_qr_code =
          "http://payapi.yogoo.net/wxzf/zfcs/MakeQRCode.aspx?wx_body=悦宝平台订单&wx_total_fee=" + this.pay_price*this.zy_discount_rate/10 * 100 +
          "&wx_ddh=" + this.wx_ddh;
      if (pay_type === '0') {
        this.version_card_bnk_00 = "version_card_chose";
        this.version_card_bnk_01 = "version_card_chose_01";
        this.version_card_bnk_02 = "version_card_chose_02";
        this.version_card_bnk_03 = "version_card_chose_03";
        this.version_card_bnk_04 = "version_card_chose_04";

        this.version_card_nk_00 = "version_card_unset";
        this.version_card_nk_01 = "version_card_unset_01";
        this.version_card_nk_02 = "version_card_unset_02";
        this.version_card_nk_03 = "version_card_unset_03";
        this.version_card_nk_04 = "version_card_unset_04";
      } else {
        this.version_card_bnk_00 = "version_card_unset";
        this.version_card_bnk_01 = "version_card_unset_01";
        this.version_card_bnk_02 = "version_card_unset_02";
        this.version_card_bnk_03 = "version_card_unset_03";
        this.version_card_bnk_04 = "version_card_unset_04";

        this.version_card_nk_00 = "version_card_chose";
        this.version_card_nk_01 = "version_card_chose_01";
        this.version_card_nk_02 = "version_card_chose_02";
        this.version_card_nk_03 = "version_card_chose_03";
        this.version_card_nk_04 = "version_card_chose_04";

      }

      // 创建定时器，每2秒执行一次updateMessage方法
      this.zfjgTimerId = setInterval(this.wx_zf_re_f, 2000);

    },

    // 查询年卡、半年卡 价格
    get_sys_app_get_price() {
      var data = {
        "product_id": '0'
      };
      product_price(data).then(
          (res) => {
            console.log("==product_price=1=", res.data.data)
            this.pay_price_jc = res.data.data.price_num;
            this.gr_sale_flag = res.data.data.sale_flag;
            var price_type = res.data.data.price_type;
            if (price_type === "0"){
              this.grb_xsmf = "限时免费";
            } else if(price_type === "3"){
              this.grb_xsmf = "永久免费";
            }

          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );

      var data2 = {
        "product_id": '1'
      };
      product_price(data2).then(
          (res) => {
            this.pay_price_bj = res.data.data.price_num;
            this.zy_sale_flag = res.data.data.sale_flag;
            this.zy_discount_flag = res.data.data.discount_flag;
            if (res.data.data.discount_flag === '1'){
              this.zy_discount_rate = res.data.data.discount_rate;
            }

          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );

    },
  }
};
</script>

<style scoped>
.hero-section {
  height: 300px;
  background: url('../../assets/index/shape-15@2x.png') center center / cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.hero-content {
  text-align: center;
  max-width: 800px;
  width: 100%;
}

.hero-title {
  color: #040404;
  font-size: 32px;
  line-height: 1.4;
  margin: 0 0 5px 0;
  font-weight: bold;
}

/* 顶部横幅区域响应式 */
@media (max-width: 768px) {
  .hero-section {
    height: auto;
    min-height: 250px;
    padding: 30px;
  }

  .hero-title {
    font-size: 24px;
    line-height: 1.3;
  }

  .sim_td_text {
    font-size: 16px !important;
    margin: 0 0 15px 0 ;
  }

  .hero-btn {
    width: 160px;
    height: 42px;
    font-size: 14px;
  }

  .sim_td_list_text {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    margin-top: 10px;
  }

  .badge {
    margin: 0 !important;
    font-size: 13px;
    padding: 6px 12px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .hero-section {
    height: 280px;
    padding: 20px;
  }

  .hero-title {
    font-size: 28px;
  }

  .sim_td_text {
    font-size: 17px;
  }
}

.important_text {
  color: #BA0B0B;
}


.hero-btn {
  background-color: #BA0B0B;
  color: #FFFFFF;
  border: none;
  border-radius: 25px;
  width: 180px;
  height: 46px;
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
}

/*
display: inline-block;
    padding: 15px 30px;
    border-radius: 30px;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    transition: all 0.3s;
    border: none;
    cursor: pointer;
*/
/*
.hero-btn {
  background-color: #BA0B0B;
  color: #FFFFFF;
  border: none;
  border-radius: 4px;
  width: 175px;
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
  padding: 12px 24px;
  font-weight: bold;
  transition: all 0.3s ease;

}*/


.version-text {
  font-size: 12px;
  font-weight: normal;
  opacity: 0.8;
  margin-top: 4px;
  color: #a99f9f;
}

.product-section {
  padding: 40px 15%;
}

/* 产品介绍区域响应式 */
@media (max-width: 768px) {
  .product-section {
    padding: 30px;
  }

  .product-title {
    font-size: 18px;
    margin: 0 0 30px 0;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .product-section {
    padding: 35px 8%;
  }

  .product-title {
    font-size: 19px;
  }
}

.product-title {
  text-align: center;
  color: #040404;
  font-size: 20px;
  margin: 0 0 50px 0;
}

.product-grid {
  max-width: 1080px;
  margin: 0 auto;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.product-item {
  flex: 1 1 0;
  padding: 0 24px;
  text-align: center;
}

.product-divider {
  width: 0;
  border-left: 1px dashed #CCCCCC;
  margin: 0 8px;
}

/* 响应式断点 */
@media (max-width: 768px) {
  .product-grid {
    flex-direction: column;
    gap: 30px;
  }

  .product-item {
    flex: none;
    padding: 0 16px;
  }

  .product-divider {
    display: none;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .product-grid {
    flex-wrap: wrap;
    gap: 15px;
  }

  .product-item {
    flex: 1 1 250px;
    padding: 0 16px;
  }
}

.product-icon {
  width: 42px;
  height: 42px;
  object-fit: contain;
  display: inline-block;
  margin-bottom: 12px;
}

.product-name {
  color: #040404;
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: bold;
}

.product-desc {
  color: #777777;
  font-size: 14px;
  line-height: 1.6;
}

/* 区域3：产品服务 */
.services-section {
  background: url('../../assets/index/shape-12@2x.png') center top / cover no-repeat;
  padding: 80px 15%;
}

.services-title {
  text-align: center;
  color: #040404;
  font-size: 20px;
  margin: 0 0 50px 0;
}

.container-align {
  max-width: 1080px;
  margin: 0 auto;
}

.services-grid {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: nowrap;
}

.service-card {
  flex: 1 1 0;
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 24px 24px 30px 24px;
  display: flex;
  flex-direction: column;
  margin: 0 12px;
}

.service-card:first-child {
  margin-left: 0;
}

.service-card:last-child {
  margin-right: 0;
}

/* 产品服务区域响应式 */
@media (max-width: 768px) {
  .services-section {
    padding: 30px;
  }

  .services-grid {
    flex-direction: column;
    gap: 20px;
  }

  .service-card {
    flex: none;
    padding: 20px;
    margin: 0;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .services-section {
    padding: 60px 8%;
  }

  .services-grid {
    flex-wrap: wrap;
    gap: 20px;
  }

  .service-card {
    flex: 1 1 250px;
    padding: 20px;
    margin: 0;
  }
}

.service-header {
  color: #040404;
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
}

.service-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 32px;
}

.service-tag-icon {
  width: 36px;
  height: 36px;
}

.service-tag-cj-icon {
  width: 14px;
  height: 14px;
  color: #BA0B0B;
  margin-right: 5px;
  align-items: end; /* 对齐到底部 */

}

.service-tag-text {
  color: #040404;
  font-size: 16px;
  font-weight: bold;
}

.service-tag-cj {
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 12px;
  height: 16px;
  border-left: 3px solid #BA0B0B;
  padding-left: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.service-tag-cj-text {
  color: #040404;
  font-size: 14px;
  font-weight: bold;
}


.service-btn {
  align-self: flex-start;
  background-color: #BA0B0B;
  color: #FFFFFF;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  height: 32px;
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
  margin: 10px 0 20px 0;
  width: 100%;
}

/* 服务按钮响应式 */
@media (max-width: 768px) {
  .service-btn {
    height: 36px;
    font-size: 13px;
    padding: 10px 16px;
  }
}

.service-features {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.feature-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #040404;
  font-size: 16px;
}

/* 特性列表响应式 */
@media (max-width: 768px) {
  .feature-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    font-size: 14px;
  }

  .feature-left {
    font-size: 13px;
  }

  .feature-right {
    font-size: 13px;
  }
}

.feature-row-cj {
  display: flex;
  align-items: center;
  color: #040404;
  font-size: 16px;
  justify-content: stretch;
}

.feature-left {
  color: #040404;
  font-size: 14px;
}

.feature-right {
  color: #d13232;
  font-size: 14px;
}

.feature-cross {
  color: #777777;
}

/* 区域4：联系我们 */
.contact-section {
  background: url('../../assets/index/lxwm-bg@2x.png') center top / cover no-repeat;
  padding: 80px 15%
}

.contact-title {
  text-align: center;
  color: #040404;
  font-size: 20px;
  margin: 0 0 50px 0;
}

.qr-row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 80px;
  margin-bottom: 50px;
}

.qr-item {
  text-align: center;
}

.qr-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.qr-caption {
  color: #040404;
  font-size: 14px;

}

.contact-row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 24px;
  gap: 40px;
}

.contact-item {
  flex: 0 0 300px;
  text-align: center;
}

.contact-head {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 6px;
}

.contact-icon {
  width: 16px;
  height: 16px;
}

.contact-label {
  color: #BA0B0B;
  font-size: 16px;
  font-weight: bold;
}

.contact-text {
  color: #040404;
  font-size: 14px;
}

.kf-tag-icon {
  width: 14px;
  height: 14px;
}

.bj-price-text {
  font-weight: bold;
  font-size: 24px;
  color: #BA0B0B;
}

.bj-ms-tag-text {
  font-weight: bold;
  font-size: 16px;
  color: #BA0B0B;
}


/* QR Code Modal Styles */
.qr-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.qr-content {
  background-color: white;
  padding: 20px;
  width: 320px;
  max-width: 90vw;
  position: relative;
  transform: translateY(-50px); /* Move the modal up by 50px */
  border-radius: 8px;
}

.qr-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px 50px;
}

.qr-title {
  margin: 0;
  color: #120605;
  font-size: 20px;
  text-align: center;
}

.qr-title2 {
  margin: 0;
  color: #717171;
  font-size: 14px;
  text-align: center;
  margin-top: -10px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  position: absolute;
  top: 10px;
  right: 10px;
}

.qr-image {
  width: 200px;
  height: 200px;
  max-width: 100%;
}

/* 弹窗响应式 */
@media (max-width: 768px) {
  .qr-content {
    width: 280px;
    padding: 15px;
  }

  .qr-body {
    padding: 15px 30px;
    gap: 15px;
  }

  .qr-title {
    font-size: 18px;
  }

  .qr-title2 {
    font-size: 13px;
  }

  .qr-image {
    width: 160px;
    height: 160px;
  }

  .close-btn {
    font-size: 20px;
    top: 8px;
    right: 8px;
  }
}

/*支付相关开始*/
.version_card_box {
  height: 150px;
  margin: 0 auto;
  border-bottom: solid 1px #EEEEEE;
  margin-bottom: 20px;
  text-align: center;
}

.version_card {
  text-align: center;
  width: 180px;
  height: 100px;
  padding-top: 20px;
  border-radius: 5px;
}

.version_pay_box {
  height: 180px;
  width: 400px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}

.version_pay_qrcode {
  width: 140px;
  height: 155px;
  border: solid 1px #EEEEEE;
  padding: 10px;
  text-align: center;
  flex-shrink: 0;
}

.version_pay_right {
  width: 200px;
  height: 155px;
  padding-top: 20px;
  padding-left: 20px;
  flex: 1;
}

/* 支付弹窗响应式 */
@media (max-width: 768px) {
  .version_card_box {
    height: auto;
    padding: 20px 10px;
  }

  .version_card {
    width: 100% !important;
    max-width: 200px;
    height: 80px;
    padding-top: 15px;
    padding-bottom:15px;
  }

  .version_pay_box {
    height: auto;
    width: 100%;
    flex-direction: column;
    gap: 15px;
  }

  .version_pay_qrcode {
    width: 120px;
    height: 140px;
    margin: 0 auto;
  }

  .version_pay_right {
    width: 100%;
    height: auto;
    padding: 10px;
    text-align: center;
  }
}

.version_card_chose {
  background-color: #FDECEC;
  border: 1px solid #F37070;
  width: 25%; /* 或具体宽度 */
  margin-left: auto;
  margin-right: auto;
  display: inline-block; /* 或 display: block; */
}

.version_card_unset {
  background-color: #FFFFFF;
  border: 1px solid #D2D2D2
}

.version_card_chose_01 {
  display: block;
  color: #682020;
  line-height: 22px;
}

.version_card_chose_02 {
  display: block;
  color: #682020;
  line-height: 14px;
  margin-bottom: 10px
}

.version_card_chose_03 {
  display: block;
  color: #EF4444;
  line-height: 30px;
}

.version_card_chose_04 {
  font-size: 18px;
  font-weight: 600
}

.version_card_unset_01 {
  display: block;
  color: #717171;
  line-height: 22px;
}

.version_card_unset_02 {
  display: block;
  color: #717171;
  line-height: 14px;
  margin-bottom: 10px
}

.version_card_unset_03 {
  display: block;
  color: #222222;
  line-height: 30px;
}

.version_card_unset_04 {
  font-size: 18px;
  font-weight: 600
}

.sim_td_text {
  font-size: 18px;
  color: #717171;
  margin: 0 0 10px 0;
}

.sim_td_list_text {

}

.badge {
  background: #FCEBBE;
  color: #717171;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;

}

.sycj-left {
  color: #717171;
  font-size: 14px;
}

/* 用户证言区域 */
.testimonials {
  padding: 80px 15%;
  background: white;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

/* 用户评价区域响应式 */
@media (max-width: 768px) {
  .contact-section {
    padding: 30px;
  }

  .testimonials-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .testimonial-card {
    padding: 20px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .contact-section {
    padding: 60px 8%;
  }

  .testimonials-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .testimonial-card {
    padding: 25px;
  }
}

.testimonial-card {
  background: #fff7f7;
  padding: 30px;
  border-radius: 15px;
  border-left: 4px solid #BA0B0B;
}

.testimonial-card p {
  font-style: italic;
  margin-bottom: 20px;
  color: #333;
  line-height: 1.6;
  font-size: 14px;
}

.testimonial-card p strong {
  color: #BA0B0B;
  font-weight: 600;
}

.testimonial-author {
  color: #666;
  font-size: 14px;
}

.testimonial-author strong {
  color: #BA0B0B;
}
</style>
